export default __webpack_public_path__ + "static/media/CNo.66-4.b71e3ced.jpg";